import { HOME_QUERY, HomePage } from '#app/queries/homepage.ts'
import { type Route } from './+types'
import { CmsSection } from '#app/components/cms-section.tsx'
import { getSeoMeta } from '#app/utils/seo/getSeoMeta.ts'
import { BASE_URL } from '#app/utils/constants.ts'

export const meta: Route.MetaFunction = ({ data }: Route.MetaArgs) => {
	const title = data?.initial?.seo?.metaTitle || 'Fallback title for the website'
	const description =
		data?.initial?.seo?.metaDescription ||
		'Fallback description for the website'
	return getSeoMeta({
		title,
		description,
		url: BASE_URL,
	})	
}

export const loader = async ({ request }: Route.LoaderArgs) => {
	const { client } = await import('#app/utils/sanity-client.ts')
	const query = HOME_QUERY.query;
	const params = {}
	const initial = await client.fetch<HomePage>(query, params)
	
	if (!initial) {
		throw new Response('Not found', { status: 404 })
	}
	return {
		initial,
		query,
		params
	}
}


export default function Index({loaderData}: Route.ComponentProps) {
	const {initial} = loaderData
	return (
		<main>
			{initial?.sections.map((section) => (<CmsSection key={section._key} data={section} />))}
		</main>
	)
}
